
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinpimpri() {



const cardData = {
  keyword: 'Cab Service in Pimpri MIDC',
  heading: 'eTravo: Trusted Corporate Cab Services in Pimpri MIDC for Seamless Business Travel',
  headingDescription: 'eTravo delivers comprehensive corporate cab solutions in Pimpri MIDC, catering to the transportation needs of businesses, employees, and executives in this major industrial and commercial zone. Our services emphasize safety, punctuality, and comfort, using GPS-enabled, air-conditioned vehicles operated by professional drivers. Whether for daily employee commutes, client pickups, or business meetings, eTravo ensures efficient, customizable transport solutions that support productivity and ease of travel across Pimpri MIDC and surrounding areas.',

  top: 'Key Industrial and Commercial Locations in Pimpri MIDC Covered by eTravo',
  topPlaces: [
    {
      title: 'Pimpri MIDC Industrial Estate',
      description: 'A major industrial hub hosting numerous manufacturing, automotive, and service sector companies. eTravo supports timely transport for employees, shift workers, and management staff across this area.'
    },
    {
      title: 'Pimpri Railway Station',
      description: 'An important transit point for daily commuters and business travelers. Our cab services provide convenient first-mile and last-mile connectivity to and from this station.'
    },
    {
      title: 'Chinchwad Commercial Area',
      description: 'A thriving business district near Pimpri MIDC. eTravo facilitates corporate travel with dedicated cab services for office workers, clients, and executives.'
    },
    {
      title: 'Automotive Manufacturing Units',
      description: 'Home to several automotive plants and suppliers requiring coordinated staff transport solutions. Our fleet offers flexible scheduling to accommodate varying shift patterns.'
    },
    {
      title: 'Pimpri Industrial Parks',
      description: 'Clusters of industrial units and warehouses demanding reliable transportation for employees and logistics personnel. We provide tailored shuttle and cab services to meet these needs.'
    },
    {
      title: 'Educational Institutions and Training Centers',
      description: 'Serving transport needs for employees and visiting trainers attending these facilities within Pimpri MIDC.'
    },
    {
      title: 'Pimpri Bus Depot',
      description: 'A central hub for public transport connections. eTravo’s corporate cabs complement public transit by offering direct, comfortable travel for business clients and staff.'
    },
    {
      title: 'Corporate Offices and Business Parks',
      description: 'Key office locations that require professional and punctual cab services for day-to-day operations and client meetings.'
    },
    {
      title: 'Local Service Providers and Suppliers',
      description: 'Our cab services support smaller businesses and suppliers in Pimpri MIDC by offering reliable transport for staff and deliveries.'
    },
    {
      title: 'Nearby Residential Complexes',
      description: 'We facilitate staff commutes by providing comfortable rides from major residential areas to industrial and commercial sites in Pimpri MIDC.'
    }
  ],

  services: [
    {
      name: 'Pimpri MIDC Corporate Cab Rentals',
      description: 'Customizable cab rental plans designed to meet the needs of diverse businesses, from startups to large corporations, with options for short-term and long-term contracts.'
    },
    {
      name: 'Employee Transport Cab Pimpri MIDC',
      description: 'Scheduled and on-demand employee transport services featuring GPS tracking, professional drivers, and multi-stop route management to ensure safe and timely commutes.'
    },
    {
      name: 'Business Cab Services Pimpri MIDC',
      description: 'Efficient cab solutions for business owners, field agents, and visiting clients, available with a range of vehicle types to suit varying corporate requirements.'
    },
    {
      name: 'Corporate Staff Cabs Pimpri MIDC',
      description: 'Dedicated staff transportation with shift-wise scheduling, real-time fleet monitoring, and flexible pickup/drop locations to optimize operational workflows.'
    },
    {
      name: 'Reliable Corporate Cab Service Pimpri MIDC',
      description: 'Recognized for timely pickups, clean and well-maintained vehicles, and courteous drivers committed to delivering hassle-free corporate transport.'
    },
    {
      name: 'AC Corporate Cabs Pimpri MIDC',
      description: 'Fully air-conditioned, sanitized, and comfortable vehicles providing an optimal travel environment for employees and clients, especially in Mumbai’s climate.'
    },
    {
      name: 'Staff Pickup and Drop Cab Pimpri MIDC',
      description: 'Round-the-clock employee pickup and drop-off services catering to multiple shifts and operational schedules, designed to enhance workforce punctuality.'
    },
    {
      name: 'Affordable Business Cab Rentals Pimpri MIDC',
      description: 'Cost-effective transportation options with flexible billing, , and contract durations, ideal for businesses looking to optimize travel expenses.'
    },
    {
      name: 'Executive Cab Services Pimpri MIDC',
      description: 'Premium cab offerings for executives and VIP clients, featuring luxury vehicles, professionally attired chauffeurs, and personalized booking support.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Pimpri MIDC',
      description: 'Comprehensive monthly rental plans that cover employee commuting, client transportation, and corporate events with real-time tracking and 24/7 support.'
    },
    {
      name: 'Industrial Area Employee Transport Pimpri MIDC',
      description: 'Specialized transport management tailored for industrial area employees, ensuring safe, reliable, and efficient travel across shift changes and multi-stop routes.'
    },
    {
      name: 'Corporate Client Cabs Pimpri MIDC',
      description: 'Professional transportation for client meetings, site visits, and corporate hospitality, helping businesses create positive and punctual impressions.'
    },
    {
      name: 'Business Meeting Cabs Pimpri MIDC',
      description: 'On-demand and scheduled cab services designed to facilitate swift and flexible travel for business meetings, client calls, and urgent site visits.'
    },
    {
      name: 'Pimpri MIDC Industrial Area Cab Hire',
      description: 'Flexible cab hire options for staff transportation, corporate events, and special requirements with scalable fleet availability to suit your business size.'
    },
    {
      name: 'Corporate Shuttle Cabs Pimpri MIDC',
      description: 'Group shuttle services designed to efficiently transport teams between offices, industrial zones, transit points, and residential locations within Pimpri MIDC.'
    }
  ],

  tableData: [
    ['Pimpri MIDC Corporate Cab Rentals', 'Employee Transport Cab Pimpri MIDC'],
    ['Business Cab Services Pimpri MIDC', 'Corporate Staff Cabs Pimpri MIDC'],
    ['Reliable Corporate Cab Service Pimpri MIDC', 'AC Corporate Cabs Pimpri MIDC'],
    ['Staff Pickup and Drop Cab Pimpri MIDC', 'Affordable Business Cab Rentals Pimpri MIDC'],
    ['Executive Cab Services Pimpri MIDC', 'Monthly Corporate Cab Rentals Pimpri MIDC'],
    ['Industrial Area Employee Transport Pimpri MIDC', 'Corporate Client Cabs Pimpri MIDC'],
    ['Business Meeting Cabs Pimpri MIDC', 'Pimpri MIDC Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Pimpri MIDC', '']
  ],


"whychoose": [
    {
        "WhyChooseheading": "Customized Corporate Cab Services for Pimpri MIDC",
        "WhyChoosedescription": "eTravo offers tailored cab solutions designed specifically for businesses in Pimpri Industrial Area MIDC. Our services focus on providing reliable, punctual, and comfortable transportation for employees, helping companies reduce commute-related stress and improve overall workforce efficiency."
    },
    {
        "WhyChooseheading": "Diverse Fleet to Meet Various Corporate Transportation Needs",
        "WhyChoosedescription": "Our extensive fleet includes a variety of vehicles such as sedans, SUVs, and MUVs, enabling companies to select vehicles that best fit their daily commuting needs, client visits, or inter-office travel across Pimpri MIDC and surrounding areas."
    },
    {
        "WhyChooseheading": "Professional Drivers Experienced with Pimpri MIDC Routes",
        "WhyChoosedescription": "Our drivers are well-trained and possess comprehensive knowledge of Pimpri MIDC routes and traffic patterns. Their expertise ensures timely pickups, efficient navigation, and reliable service, minimizing delays for your corporate teams."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for Corporate Clients",
        "WhyChoosedescription": "We offer flexible booking options including on-demand rides, scheduled pickups, and long-term contracts, allowing businesses to adapt their transportation plans according to employee shift timings and project requirements."
    },
    {
        "WhyChooseheading": "Real-Time GPS Tracking for Enhanced Safety and Transparency",
        "WhyChoosedescription": "All our vehicles are equipped with GPS tracking systems, allowing corporate clients to monitor trips in real time, ensuring passenger safety, timely arrivals, and full transparency throughout the journey."
    },
    {
        "WhyChooseheading": "Transparent and Detailed Billing for Simplified Expense Management",
        "WhyChoosedescription": "We provide clear, itemized invoices with trip logs and fare breakdowns, making it easier for corporate finance teams to manage transportation expenses and process reimbursements efficiently."
    },
    {
        "WhyChooseheading": "Strict Safety and Hygiene Protocols to Protect Passengers",
        "WhyChoosedescription": "Our vehicles undergo regular sanitization, and drivers adhere to strict hygiene standards including mask-wearing and hand sanitizing, ensuring a safe and healthy travel environment for all employees."
    },
    {
        "WhyChooseheading": "Dedicated Account Management for Corporate Support",
        "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager to assist with bookings, address any concerns promptly, and provide personalized support for a seamless transportation experience."
    }
]
}

const faqData = [
    [
        {
            question: "Which areas does your corporate cab service cover in Pimpri MIDC?",
            answer: "Our services cover Pimpri Industrial Area MIDC along with nearby zones such as Chinchwad, Bhosari, and other key industrial and commercial hubs in Pune."
        },
        {
            question: "Can we schedule recurring rides for our employees?",
            answer: "Yes, we provide options to schedule recurring rides to ensure consistent and reliable transportation for your workforce."
        },
        {
            question: "Do you offer monthly billing for corporate clients?",
            answer: "Certainly. We provide monthly billing cycles with detailed invoices to streamline your company's expense management."
        },
        {
            question: "Are your drivers trained in corporate professionalism?",
            answer: "Yes, our drivers receive training in corporate etiquette to ensure a professional and courteous travel experience for all passengers."
        },
        {
            question: "How do you ensure passenger safety during rides?",
            answer: "We utilize GPS tracking, conduct regular vehicle maintenance, and follow strict hygiene protocols to maintain high safety standards."
        },
        {
            question: "Is there dedicated support available for corporate clients?",
            answer: "Yes, corporate clients have access to dedicated account managers and support lines for prompt assistance and service customization."
        }
    ]
];

const testimonialsData = [
    {
        name: "Mr. Prakash Deshmukh",
        designation: "Operations Head, Zenith Manufacturing",
        rating: [1, 1, 1, 1, 1],
        text: "“eTravo’s cab service in Pimpri MIDC has made our employee transportation hassle-free with timely pickups and professional drivers.”"
    },
    {
        name: "Ms. Kavita Rao",
        designation: "HR Manager, Pinnacle Industries",
        rating: [1, 1, 1, 1, 1],
        text: "“The transparency in billing and flexibility in bookings offered by eTravo make them an excellent choice for corporate travel in Pimpri.”"
    }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Pimpri MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-pimpri-midc.jpg",
  "description": "Reliable cab services in Pimpri MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable AC corporate cabs with professional drivers by eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7841"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-pimpri-midc"
  }
};








    return (
        <div>

<Helmet>
  <title>Cab Service in Pimpri MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab services in Pimpri MIDC for corporate staff transport, business meetings, and industrial area commutes. Affordable and reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinpimpri;